import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HomeIcon from '@mui/icons-material/Home';
import FlightIcon from '@mui/icons-material/Flight';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import SchoolIcon from '@mui/icons-material/School';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LaptopIcon from '@mui/icons-material/Laptop';
import ChairIcon from '@mui/icons-material/Chair';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import GroupsIcon from '@mui/icons-material/Groups';
import SpaIcon from '@mui/icons-material/Spa';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BusinessIcon from '@mui/icons-material/Business';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import RedeemIcon from '@mui/icons-material/Redeem';
import TvIcon from '@mui/icons-material/Tv';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export * from './theme';

export const categoryIconsAndColors = {
  'Business Income': {
    color: '#81C784', // Lighter green color
    icon: <BusinessIcon />,
  },
  Stocks: {
    color: '#4CAF50',
    icon: <ShowChartIcon />,
  },
  'Food & Dining': {
    color: '#748B9B',
    icon: <RestaurantIcon />,
  },
  Entertainment: {
    color: '#3C6079',
    icon: <LocalActivityIcon />,
  },
  'Transport + Auto': {
    color: '#CD99BB',
    icon: <DirectionsCarIcon />,
  },
  Home: {
    color: '#8D6E63',
    icon: <HomeIcon />,
  },
  Travel: {
    color: '#26A69A',
    icon: <FlightIcon />,
  },
  Healthcare: {
    color: '#EF5350',
    icon: <LocalHospitalIcon />,
  },
  Clothing: {
    color: '#EC407A',
    icon: <ShoppingBagIcon />,
  },
  Education: {
    color: '#AB47BC',
    icon: <SchoolIcon />,
  },
  'Charitable Donations': {
    color: '#7E57C2',
    icon: <VolunteerActivismIcon />,
  },
  'Financial + Legal Fees': {
    color: '#5C6BC0',
    icon: <AccountBalanceIcon />,
  },
  'Electronics & Software': {
    color: '#42A5F5',
    icon: <LaptopIcon />,
  },
  'Home Furnishings': {
    color: '#29B6F6',
    icon: <ChairIcon />,
  },
  Gifts: {
    color: '#26C6DA',
    icon: <CardGiftcardIcon />,
  },
  'Club Memberships': {
    color: '#26A69A',
    icon: <GroupsIcon />,
  },
  'Personal Services': {
    color: '#66BB6A',
    icon: <SpaIcon />,
  },
  'Wellness + Fitness': {
    color: '#9CCC65',
    icon: <SpaIcon />,
  },
  Taxes: {
    color: '#D4E157',
    icon: <ReceiptIcon />,
  },
  'Dues and Subscriptions': {
    color: '#FFB74D',
    icon: <SubscriptionsIcon />,
  },
  Charity: {
    color: '#FF8A65',
    icon: <RedeemIcon />,
  },
  Television: {
    color: '#90A4AE',
    icon: <TvIcon />,
  },
  Groceries: {
    color: '#AED581',
    icon: <LocalGroceryStoreIcon />,
  },
  Gas: {
    color: '#FFD54F',
    icon: <LocalGasStationIcon />,
  },
  Paycheck: {
    color: '#A1887F',
    icon: <AttachMoneyIcon />,
  },
};
